export const declarationList = [
    {
        name: "全部",
        value: "",
    },
    {
        name: "省级机关单位",
        value: "省级机关单位",
    },
    {
        name: "各设区市社科联",
        value: "各设区市社科联",
    },
    {
        name: "县（市、区）社科联",
        value: "县（市、区）社科联",
    },
    {
        name: "高校社科联",
        value: "高校社科联",
    },
    {
        name: "全省性社科类社会组织",
        value: "全省性社科类社会组织",
    },
    {
        name: "省级社科普及基地",
        value: "省级社科普及基地",
    },
    {
        name: "市级机关单位",
        value: "市级机关单位",
    },
    {
        name: "市县级社科普及基地",
        value: "市县级社科普及基地",
    },
    {
        name: "其他",
        value: "其他",
    },
]
export const sustainableList = [
    {
        name: "请选择",
        value: "",
    },
    {
        name: "是",
        value: "是",
    },
    {
        name: "否",
        value: "否",
    },
]
export const audienceList = [
    {
        name: "请选择",
        value: "",
    },
    {
        name: "青少年",
        value: "青少年",
    },
    {
        name: "城镇劳动者",
        value: "城镇劳动者",
    },
    {
        name: "进城务工人员",
        value: "进城务工人员",
    },
    {
        name: "农民",
        value: "农民",
    },
    {
        name: "党员干部和公务员",
        value: "党员干部和公务员",
    },
    {
        name: "其他",
        value: "其他",
    },
]
export const projectTypeList = [
    {
        name: "请选择",
        value: "",
    },
    {
        name: "普及活动类",
        value: "普及活动类",
    },
    {
        name: "新媒体传播类",
        value: "新媒体传播类",
    },
    {
        name: "普及成果类",
        value: "普及成果类",
    },
    {
        name: "普及服务类",
        value: "普及服务类",
    },
]
export const planningSourceList = [
    {
        name: "请选择",
        value: "",
    },
    {
        name: "1.宣传阐释党的二十大精神、习近平新时代中国特色社会主义思想、习近平文化思想，推动马克思主义大众化",
        value: "宣传阐释党的二十大精神、习近平新时代中国特色社会主义思想、习近平文化思想，推动马克思主义大众化",
    },
    {
        name: "2.培育和弘扬社会主义核心价值观",
        value: "培育和弘扬社会主义核心价值观",
    },
    {
        name: "3.形象化、通俗化阐释中国式现代化的科学内涵、本质要求、中国特色等",
        value: "形象化、通俗化阐释中国式现代化的科学内涵、本质要求、中国特色等",
    },
    {
        name: "4.普及宣传中国式现代化江苏新实践，宣传阐释新质生产力、人文经济学等重要概念，面向群众解读省委省政府推进高质量发展、创造高品质生活的重要决策部署",
        value: "普及宣传中国式现代化江苏新实践，宣传阐释新质生产力、人文经济学等重要概念，面向群众解读省委省政府推进高质量发展、创造高品质生活的重要决策部署",
    },
    {
        name: "5.传承弘扬中华优秀传统文化，建设中华民族现代文明",
        value: "传承弘扬中华优秀传统文化，建设中华民族现代文明",
    },
    {
        name: "6.普及江苏地方文化，宣传打造具有地方特色的名人民风民俗、城市文化标识等特色文化普及品牌",
        value: "普及江苏地方文化，宣传打造具有地方特色的名人民风民俗、城市文化标识等特色文化普及品牌",
    },
    {
        name: "7.以公益咨询服务方式普及与社会民生密切相关的法律、教育、金融、环保、心理等知识",
        value: "以公益咨询服务方式普及与社会民生密切相关的法律、教育、金融、环保、心理等知识",
    },
    {
        name: "8.普及宣传人文社会科学相关的学科知识",
        value: "普及宣传人文社会科学相关的学科知识",
    },

]
export const appropriationList = [
    {
        name: "请选择",
        value: "",
    },
    {
        name: "是",
        value: "是",
    },
    {
        name: "否",
        value: "否",
    },
]
export const subsidizeList = [
    {
        name: "请选择",
        value: "",
    },
    {
        name: "品牌项目",
        value: "品牌项目",
    },
    {
        name: "协作项目",
        value: "协作项目",
    },
]
/*
import {
    appropriationList,
    audienceList,
    declarationList,
    planningSourceList,
    projectTypeList,
    subsidizeList,
    sustainableList,
} from '@/plugins/optionList'
declarationList: declarationList,
        sustainableList: sustainableList,
        audienceList: audienceList,
        projectTypeList: projectTypeList,
        planningSourceList: planningSourceList,
        appropriationList: appropriationList,
        subsidizeList: subsidizeList,

        */
